/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type InviteFriendContainer_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type NewUserTourContainer_user$ref: FragmentReference;
export type NewUserTourContainer_user = {|
  +$fragmentRefs: InviteFriendContainer_user$ref,
  +$refType: NewUserTourContainer_user$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "NewUserTourContainer_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "InviteFriendContainer_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '09192f1c237709ffd84b9d2d3c9dcc6c';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/components/Dashboard/__generated__/NewUserTourContainer_user.graphql.js